import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "../components/DismissibleToast";
import SectionLoader from "../components/sectionLoader/SectionLoader";
import authAPI from "../services/auth/auth.service";
import { AuthContext } from "../services/AuthProvider";

const AuthCallback = () => {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const auth = useContext(AuthContext);

  useEffect(() => {
    const login = async () => {
      try {
        const response = await authAPI?.getToken(window?.location?.search);
        if (response?.status === 200) {
          await auth.login(response?.data);
          navigate("/");
        } else {
          const message = response?.status === 400 ? "User Not Found" : "Failed to login";
          toast.error(message, { duration: 10000 });
          if (window.location.pathname !== "/app/logout") {
            navigate("/app/logout");
          }
        }
      } catch (error) {
        toast.error("Error Logging In");
        console.error("Error Logging In: ", error);
      } finally {
        setIsLoading(false);
      }
    };
    login();
  }, [auth, navigate]);

  if (isLoading) {
    return <SectionLoader />;
  }

  return null;
};

export default AuthCallback;
